import {
  boolean,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod";

export const setTeamworkCommerceIntegration = {
  name: "setTeamworkCommerceIntegration" as const,
  input: object({
    baseUrl: string(),
    apiKey: string(),
    importReceiptSettings: object({
      enabled: boolean().optional(),
      exchangeAdjustmentChargeId: string().optional(),
      exchangeAdjustmentMemo: string().optional(),
      fillFromLocationId: string().optional(),
      greenReturnItemSku: string().optional(),
      importReceiptLocationId: string().optional(),
      shippingChargeId: string().optional(),
    }).optional(),
  }),
  output: zNull(),
};

export type SetTeamworkCommerceIntegrationInput = zInfer<
  typeof setTeamworkCommerceIntegration.input
>;
